import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Contexts
import { AuthProvider, TimerProvider } from "./contexts";

// Router
import { AppRouter } from "./router";

// Components
import InactivityModal from "./components/InactivityModal";

// Re-export for backward compatibility
export { AuthContext, useAuth, API } from "./contexts/AuthContext";
export { TimerContext, useTimer } from "./contexts/TimerContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TimerProvider>
          <Toaster position="top-right" richColors />
          <InactivityModal />
          <AppRouter />
        </TimerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
